import { defineMessages } from 'react-intl'

const scope = `procurify.platform.banking.presenter.GetFinancialAccountBalanceSummaryPresenter`

export default defineMessages({
  fetchingBalanceSummaryToastError: {
    id: `${scope}.fetchingBalanceSummaryToastError`,
    defaultMessage: 'Error fetching balance summary',
  },
})
